import { render } from "./headerComponent.vue?vue&type=template&id=0aa39f9e&ts=true"
import script from "./headerComponent.vue?vue&type=script&lang=ts"
export * from "./headerComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__